import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { Spinner, Image } from "react-bootstrap";
import Footer from "../Footer";

function BlogDetail() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    useEffect(() => {
        document.title = `Jobbox.one | Articles-blogs - ${slug}`;
    }, []);
    useEffect(() => {
        axios
            .get(
                `http://51.79.18.21:1337/api/jobboxarticles?filters[slug][$eq]=${slug}&populate=*`
            )
            .then((res) => {
                const items = res.data.data || [];
                if (items.length > 0) setArticle(items[0]);
                else setArticle(null);
            })
            .catch((err) => console.error("Error fetching article:", err));
    }, [slug]);

    if (!article)
        return (
            <div style={{ textAlign: "center", padding: "80px 20px" }}>
                <Spinner animation="border" role="status" />
                <p style={{ marginTop: "16px", fontSize: "18px", color: "#555" }}>
                    Loading article...
                </p>
            </div>
        );

    const imageUrl = article.image?.url
        ? `http://51.79.18.21:1337${article.image.url}`
        : null;

    return (
        <div>
            {/* Header stays the same */}
            <header
                style={{
                    padding: "16px 40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #eee",
                    backgroundColor: "white",
                }}
            >
                <a href="/">
                    <Image
                        src="/jb_logo.png"
                        alt="Jobbox Logo"
                        fluid
                        style={{
                            width: "180px",
                            height: "auto",
                            cursor: "pointer",
                        }}
                    />
                </a>
            </header>

            {/* Article Content */}
            <main
                style={{
                    backgroundColor: "#f9fafb",
                    minHeight: "100vh",
                    padding: "40px 20px",
                }}
            >
                <div
                    style={{
                        maxWidth: "860px",
                        margin: "0 auto",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "2.5rem",
                            lineHeight: "1.3",
                            fontWeight: "700",
                            marginBottom: "24px",
                            color: "#111827",
                        }}
                    >
                        {article.Title}
                    </h1>

                    {/* Article Image */}
                    {imageUrl && (
                        <div style={{ marginBottom: "28px" }}>
                            <img
                                src={imageUrl}
                                alt={article.Title}
                                style={{
                                    width: "100%",
                                    maxHeight: "300px",   // reduced height
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                    boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
                                }}
                            />
                        </div>
                    )}


                    {/* Article Description */}
                    <div
                        style={{
                            fontSize: "1.125rem",
                            lineHeight: "1.8",
                            color: "#374151",
                        }}
                    >
                        {article.Description && (
                            <BlocksRenderer content={article.Description} />
                        )}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default BlogDetail;
